<template>
  <div class="pa-3">
    <div
      v-if="loading"
      class="d-flex align-center"
      style="width: 100%; min-height: 200px"
    >
      <v-row no-gutters align="start">
        <v-col cols="12" md="3" class="d-flex justify-center my-3">
          <v-skeleton-loader
            width="45%"
            height="20vh"
            type="image"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="9">
          <v-skeleton-loader type="table-thead"></v-skeleton-loader>
          <v-skeleton-loader type="table-thead"></v-skeleton-loader>
          <v-skeleton-loader type="table-thead"></v-skeleton-loader>
          <v-skeleton-loader type="table-thead"></v-skeleton-loader>
          <v-skeleton-loader type="table-thead"></v-skeleton-loader>
          <v-skeleton-loader type="table-thead"></v-skeleton-loader>
          <v-skeleton-loader type="table-thead"></v-skeleton-loader>
        </v-col>
      </v-row>
    </div>
    <v-row no-gutters v-if="!loading && dataSet">
      <v-col cols="12">
        <title-page
          title="Edit Profile"
          back="true"
          colorIconBack="#006341"
        ></title-page>
      </v-col>
      <v-col cols="12" md="3" class="pa-4 my-2">
        <v-card
          style="height: max-content; width: 100%"
          class="d-flex flex-column align-center rounded-xl justify-center pa-2"
        >
          <div class="pa-2 avatar_ppl">
            <v-avatar size="150">
              <v-img
                :src="dataSet.profile_picture ? dataSet.profile_picture : ava"
              />
            </v-avatar>
          </div>

          <h3 class="my-1" style="color: #006341">{{ dataSet.name }}</h3>
          <h5 class="my-1" style="color: #006341">{{ dataSet.email }}</h5>
        </v-card>
      </v-col>
      <v-col cols="12" md="9" class="pa-4 my-3">
        <v-card class="pa-4 rounded-xl">
          <div class="my-1" v-for="(item, index) in dataBody" :key="index">
            <div v-if="item['type'] == 'string'">
              <h4 class="text-capitalize">{{ item.label }}</h4>
              <v-text-field
                v-if="
                  item.name == 'username' ||
                  item.name == 'email' ||
                  item.name == 'password'
                "
                class="my-1"
                :placeholder="item.name"
                rounded
                dense
                readonly
                filled
                v-model="item.value"
              ></v-text-field>
              <v-select
                v-if="item.name == 'province'"
                dense
                rounded
                outlined
                :items="optProvinces"
                item-text="name"
                item-value="id"
                v-model="item.value"
                @change="fetchDataRegencies"
                placeholder="Choose Provinces"
                flat
                solo
              ></v-select>
              <v-select
                v-if="item.name == 'city'"
                dense
                rounded
                outlined
                :items="optRegencies"
                item-text="name"
                item-value="id"
                v-model="item.value"
                @change="fetchDataDistrict"
                placeholder="Choose Regencies"
                flat
                solo
              ></v-select>
              <v-select
                v-if="item.name == 'village'"
                dense
                rounded
                outlined
                :items="optDistrict"
                item-text="name"
                item-value="id"
                v-model="item.value"
                @change="fetchDataVillage"
                placeholder="Choose District"
                flat
                solo
              ></v-select>
              <v-select
                v-if="item.name == 'religion'"
                dense
                rounded
                outlined
                :items="optReligion"
                item-text="txt"
                item-value="val"
                v-model="item.value"
                placeholder="Choose Religion"
                flat
                solo
              ></v-select>

              <v-text-field
                v-if="
                  item.name != 'username' &&
                  item.name != 'email' &&
                  item.name != 'password' &&
                  item.name != 'province' &&
                  item.name != 'city' &&
                  item.name != 'village' &&
                  item.name != 'religion'
                "
                outlined
                class="my-1"
                :placeholder="item.name"
                rounded
                dense
                v-model="item.value"
              ></v-text-field>
            </div>
            <div v-if="item.type == 'integer'">
              <h4 class="text-capitalize">{{ item.label }}</h4>
              <v-select
                v-if="item.name == 'university_id'"
                dense
                rounded
                outlined
                :items="optUniv"
                item-text="name"
                item-value="id"
                v-model="item.value"
                placeholder="Choose University"
                flat
                solo
              ></v-select>
              <v-text-field
                v-else
                class="my-1"
                outlined
                :placeholder="item.name"
                rounded
                dense
                type="number"
                v-model="item.value"
              ></v-text-field>
            </div>
            <div v-if="item.type == 'date'">
              <h4 class="text-capitalize">{{ item.label }}</h4>
              <v-menu
                v-model="showPicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="item.value"
                    prepend-inner-icon="mdi-calendar-range"
                    outlined
                    readonly
                    rounded
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="item.value"
                  @input="closeDateMenu(item, index)"
                ></v-date-picker>
              </v-menu>
            </div>
            <div v-if="item.type == 'enum'">
              <h4 class="text-capitalize">{{ item.label }}</h4>
              <v-radio-group
                v-if="item.name != 'type'"
                v-model="item.value"
                class="mt-1 mb-2"
                hide-details
                dense
                row
              >
                <v-radio
                  label="Male"
                  color="green"
                  value="Male"
                ></v-radio>
                <v-radio
                  label="Female"
                  color="green"
                  value="Female"
                ></v-radio>
              </v-radio-group>
              <v-radio-group
                v-model="item.value"
                v-if="item.name == 'type'"
                class="mt-1 mb-2"
                hide-details
                dense
                row
              >
                <v-radio
                  label="Regular"
                  color="green"
                  value="regular"
                ></v-radio>
                <v-radio
                  label="Non Regular"
                  color="green"
                  value="non-regular"
                ></v-radio>
              </v-radio-group>
            </div>
            <div v-if="item.type == 'text'">
              <h4 class="text-capitalize">{{ item.label }}</h4>
              <div
                v-if="
                  item.name == 'historical_edu' ||
                  item.name == 'achievement' ||
                  item.name == 'orgs_activity' ||
                  item.name == 'language_ability' ||
                  item.name == 'father_latest_edu' ||
                  item.name == 'mother_latest_edu' ||
                  item.name == 'acc_socmed' ||
                  item.name == 'address'
                "
              >
                <div v-if="item.name == 'address'">
                  <v-textarea
                    rounded
                    outlined
                    auto-grow
                    rows="4"
                    :placeholder="item.name"
                    v-model="item.value"
                    dense
                  ></v-textarea>
                </div>
                <div class="pa-3" v-if="item.name == 'acc_socmed'">
                  <div
                    v-for="(sosmed, idx) in acc_socmed"
                    :key="`sosmed-${idx}`"
                  >
                    <h6 style="font-weight: normal" class="text-capitalize">
                      {{ sosmed.name }}
                    </h6>
                    <v-text-field
                      class="my-1"
                      outlined
                      :placeholder="sosmed.name"
                      v-model="sosmed.value"
                      rounded
                      dense
                    ></v-text-field>
                  </div>
                </div>
                <div class="pa-3" v-if="item.name == 'achievement'">
                  <div
                    v-for="(achievementItem, idx) in achievement"
                    :key="`achievementItem-${idx}`"
                  >
                    <h6 style="font-weight: normal" class="text-capitalize">
                      {{ `Achievement ${idx + 1}` }}
                    </h6>
                    <v-text-field
                      class="my-1"
                      outlined
                      :placeholder="`Achievement ${idx + 1}`"
                      rounded
                      dense
                      v-model="achievementItem.val"
                    ></v-text-field>
                  </div>
                </div>
                <div class="pa-3" v-if="item.name == 'historical_edu'">
                  <div
                    v-for="(historical_eduItem, idx) in historical_edu"
                    :key="`historical_eduItem-${idx}`"
                  >
                    <h6 style="font-weight: normal" class="text-capitalize">
                      {{ `Education ${idx + 1}` }}
                    </h6>
                    <v-text-field
                      class="my-1"
                      outlined
                      :placeholder="`Education ${idx + 1}`"
                      rounded
                      dense
                      v-model="historical_eduItem.val"
                    ></v-text-field>
                  </div>
                </div>
                <div class="pa-3" v-if="item.name == 'orgs_activity'">
                  <div
                    v-for="(orgs_activityItem, idx) in orgs_activity"
                    :key="`orgs_activityItem-${idx}`"
                  >
                    <h6 style="font-weight: normal" class="text-capitalize">
                      {{ `Organization activity ${idx + 1}` }}
                    </h6>
                    <v-text-field
                      class="my-1"
                      outlined
                      :placeholder="`Organization activity ${idx + 1}`"
                      rounded
                      dense
                      v-model="orgs_activityItem.val"
                    ></v-text-field>
                  </div>
                </div>
                <div class="pa-3" v-if="item.name == 'father_latest_edu'">
                  <div
                    v-for="(father_latest_eduItem, idx) in father_latest_edu"
                    :key="`father_latest_eduItem-${idx}`"
                  >
                    <h6 style="font-weight: normal" class="text-capitalize">
                      {{ `Father Education ${idx + 1}` }}
                    </h6>
                    <v-text-field
                      class="my-1"
                      outlined
                      :placeholder="`Father Education ${idx + 1}`"
                      rounded
                      dense
                      v-model="father_latest_eduItem.val"
                    ></v-text-field>
                  </div>
                </div>
                <div class="pa-3" v-if="item.name == 'mother_latest_edu'">
                  <div
                    v-for="(mother_latest_eduItem, idx) in mother_latest_edu"
                    :key="`mother_latest_eduItem-${idx}`"
                  >
                    <h6 style="font-weight: normal" class="text-capitalize">
                      {{ `Mother Education ${idx + 1}` }}
                    </h6>
                    <v-text-field
                      class="my-1"
                      outlined
                      :placeholder="`Mother Education ${idx + 1}`"
                      rounded
                      dense
                      v-model="mother_latest_eduItem.val"
                    ></v-text-field>
                  </div>
                </div>
                <div class="pa-3" v-if="item.name == 'language_ability'">
                  <div
                    v-for="(language_abilityItem, idx) in language_ability"
                    :key="`language_abilityItem-${idx}`"
                  >
                    <h5 class="text-capitalize">
                      {{ `Language Ability ${idx + 1}` }}
                    </h5>
                    <h6 style="font-weight: normal" class="text-capitalize">
                      Bahasa
                    </h6>
                    <v-text-field
                      class="my-1"
                      outlined
                      placeholder="Bahasa"
                      rounded
                      dense
                      v-model="language_abilityItem.bahasa"
                    ></v-text-field>
                    <h6 style="font-weight: normal" class="text-capitalize">
                      Memiliki Sertifikasi
                    </h6>
                    <v-text-field
                      class="my-1"
                      outlined
                      placeholder="Memiliki Sertifikasi"
                      rounded
                      dense
                      v-model="language_abilityItem['Memiliki Sertifikasi']"
                    ></v-text-field>
                    <h6 style="font-weight: normal" class="text-capitalize">
                      Jenis Tes
                    </h6>
                    <v-text-field
                      class="my-1"
                      outlined
                      placeholder="Jenis Tes"
                      rounded
                      dense
                      v-model="language_abilityItem['Jenis Tes']"
                    ></v-text-field>
                    <h6 style="font-weight: normal" class="text-capitalize">
                      Skor
                    </h6>
                    <v-text-field
                      class="my-1"
                      outlined
                      placeholder="Skor"
                      rounded
                      dense
                      v-model="language_abilityItem['Skor']"
                    ></v-text-field>
                    <h6 style="font-weight: normal" class="text-capitalize">
                      Tahun Sertifikat
                    </h6>
                    <v-text-field
                      class="my-1"
                      outlined
                      placeholder="Tahun Sertifikat"
                      rounded
                      dense
                      v-model="language_abilityItem['Tahun Sertifikat']"
                    ></v-text-field>
                    <h6 style="font-weight: normal" class="text-capitalize">
                      Nama Lembaga Bahasa
                    </h6>
                    <v-text-field
                      class="my-1"
                      outlined
                      placeholder="Nama Lembaga Bahasa"
                      rounded
                      dense
                      v-model="language_abilityItem['Nama Lembaga Bahasa']"
                    ></v-text-field>
                    <h6 style="font-weight: normal" class="text-capitalize">
                      Masa Berlaku
                    </h6>
                    <v-text-field
                      class="my-1"
                      outlined
                      placeholder="Masa Berlaku"
                      rounded
                      dense
                      v-model="language_abilityItem['Masa Berlaku']"
                    ></v-text-field>
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  v-if="item.value != null && item.change == false"
                  class="pa-2"
                >
                  <v-card
                    max-width="200px"
                    class="d-flex align-start justify-center pa-2"
                  >
                    <v-img :lazy-src="ava" :src="item['value']" contain></v-img>
                    <v-btn small icon @click="deleteImage(index)">
                      <v-icon color="red lighten-1"> mdi-delete</v-icon>
                    </v-btn>
                  </v-card>
                </div>
                <v-file-input
                  v-else
                  outlined
                  hide-details
                  dense
                  rounded
                  :rules="rules"
                  accept=".docx, .pdf, .jpg"
                  placeholder="Upload File"
                  prepend-inner-icon="mdi-image"
                  prepend-icon=""
                  :label="item.label"
                  v-model="item.valueChange"
                  clear-icon
                ></v-file-input>
              </div>
            </div>
          </div>
        </v-card>
        <v-col cols="12" class="d-flex justify-end">
          <v-btn rounded color="success" @click="updateData">
            <h4 v-if="!loading">Update Data</h4>
            <h4 v-if="loading">Loading...</h4>
          </v-btn>
        </v-col>
      </v-col>
    </v-row>
    <dialog-medium
      :d_create="d_create"
      @refetch="reload"
      @close="d_create = false"
      :inventory="inventory"
      :type="d_type"
      :title="d_title"
    />
  </div>
</template>

<script>
// import DialogMedium from "../../dialog/dialogMedium.vue";
import { mapState } from "vuex";
import TitlePage from "../../../components/atom/titlePage.vue";
export default {
  components: {
    // DialogMedium,
    TitlePage,
  },
  name: "profile",
  computed: {
    ...mapState({
      role: (state) => state.role,
      permissions: (state) => state.permissions,
      ava: (state) => state.ava,
    }),
  },
  data() {
    return {
      d_create: false,
      inventory: null,
      d_type: "",
      d_title: "",
      loading: true,
      dataSet: null,
      dataBody: [],
      dataForm: null,
      showPicker: false,
      optProvinces: [],
      optRegencies: [],
      optDistrict: [],
      optVillage: [],
      optUniv: [],
      rules: [
        (value) =>
          !value ||
          value.size < 4000000 ||
          "File size should be less than 4 MB!",
      ],
      acc_socmed: [
        {
          name: "Instagram",
          value: "",
        },
        {
          name: "Linkedin",
          value: "",
        },
        {
          name: "Facebook",
          value: "",
        },
        {
          name: "Youtube",
          value: "",
        },
        {
          name: "Twitter",
          value: "",
        },
      ],
      historical_edu: [
        {
          val: "",
        },
        {
          val: "",
        },
        {
          val: "",
        },
      ],
      achievement: [
        {
          val: "",
        },
        {
          val: "",
        },
        {
          val: "",
        },
      ],
      orgs_activity: [
        {
          val: "",
        },
        {
          val: "",
        },
        {
          val: "",
        },
      ],
      mother_latest_edu: [
        {
          val: "",
        },
        {
          val: "",
        },
        {
          val: "",
        },
      ],
      father_latest_edu: [
        {
          val: "",
        },
        {
          val: "",
        },
        {
          val: "",
        },
      ],
      language_ability: [
        {
          bahasa: "",
          "Memiliki Sertifikasi": "",
          "Jenis Tes": "",
          Skor: "",
          "Tahun Sertifikat": "",
          "No. Sertifikat": "",
          "Nama Lembaga Bahasa": "",
          "Masa Berlaku": "",
        },
        {
          bahasa: "",
          "Memiliki Sertifikasi": "",
          "Jenis Tes": "",
          Skor: "",
          "Tahun Sertifikat": "",
          "No. Sertifikat": "",
          "Nama Lembaga Bahasa": "",
          "Masa Berlaku": "",
        },
        {
          bahasa: "",
          "Memiliki Sertifikasi": "",
          "Jenis Tes": "",
          Skor: "",
          "Tahun Sertifikat": "",
          "No. Sertifikat": "",
          "Nama Lembaga Bahasa": "",
          "Masa Berlaku": "",
        },
      ],
      optReligion: [
        { txt: "Islam", val: "islam" },
        { txt: "Katolik", val: "katolik" },
        { txt: "Konghucu", val: "konghucu" },
        { txt: "Kristen", val: "kristen" },
        { txt: "Hindu", val: "hindu" },
        { txt: "Buddha", val: "buddha" },
      ],
    };
  },
  async mounted() {
    this.dataUniv();
    this.fetchData();
  },
  methods: {
    reload() {
      window.location.reload();
      this.fetchData();
    },
    updatePhotoProfile() {
      this.d_type = "u_photoProfileScholar";
      this.d_title = "Update Photo Scholar";
      this.d_create = true;
      this.inventory = this.dataSet;
    },
    closeDateMenu(item, index) {
      this.showPicker = false;
      this.dataBody[index]["value"] == ""
        ? this.date.format("dddd, MMMM Do YYYY")
        : "";
    },
    dataUniv() {
      let data = {
        path: `manage/univ/get`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.optUniv = data.data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `scholar?scholar_id=${this.$route.params.idScholar}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then(async (data) => {
          this.dataSet = data;
          this.fetchDataProvince();
          if (this.dataSet.province) {
            this.dataSet.province = parseInt(this.dataSet.province);
            await this.fetchDataRegencies(this.dataSet.province);
          }
          if (this.dataSet.city) {
            this.dataSet.city = parseInt(this.dataSet.city);
            await this.fetchDataDistrict(this.dataSet.city);
          }
          if (this.dataSet.village) {
            this.dataSet.village = parseInt(this.dataSet.village);
          }
          await this.getForm();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchDataProvince() {
      let data = {
        path: `region/province`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then(async (data) => {
          this.optProvinces = data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    async fetchDataRegencies(item) {
      let data = {
        path: `region/regency?province_id=${item}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then(async (data) => {
          this.optRegencies = data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    async fetchDataDistrict(item) {
      let data = {
        path: `region/district?regency_id=${item}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then(async (data) => {
          this.optDistrict = data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    fetchDataVillage(item) {
      let data = {
        path: `region/village?district_id  =${item}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then(async (data) => {
          this.optVillage = data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    deleteImage(index) {
      this.dataBody[index]["change"] = true;
      this.dataBody[index]["value"] = null;
    },
    async getForm() {
      this.dataBody = [];
      this.dataForm = null;
      let data = {
        path: `manage/scholar/form`,
        type: "form",
      };
      await this.$store
        .dispatch("user/getUser", data)
        .then(async (data) => {
          this.dataForm = data;

          for (let index = 0; index < this.dataForm.length; index++) {
            var tempName = this.dataForm[index].name.replace(/ /g, "");
            var tempLabel = this.dataForm[index].label;
            if (tempName == "acc_sosmed") {
              tempName = "acc_socmed";
            }
            this.dataBody.push({
              type: this.dataForm[index].type,
              name: tempName,
              label: tempLabel,
              value:
                this.dataSet[tempName] != null
                  ? this.dataSet[tempName]
                  : this.dataForm[index].type == "text"
                  ? !this.dataSet[tempName]
                    ? null
                    : this.dataSet[tempName]
                  : "",
              required: this.dataForm[index].required,
              valueChange:
                this.dataForm[index].type == "text"
                  ? null
                  : this.dataSet[tempName],
              change: false,
            });
            if (this.dataBody[index]["label"] == "province") {
              if (this.dataBody[index]["value"]) {
                this.dataBody[index]["value"] = parseInt(
                  this.dataBody[index]["value"]
                );
              }
            }
            if (this.dataBody[index]["label"] == "city") {
              if (this.dataBody[index]["value"]) {
                this.dataBody[index]["value"] = parseInt(
                  this.dataBody[index]["value"]
                );
              }
            }
            if (this.dataBody[index]["label"] == "village") {
              if (this.dataBody[index]["value"]) {
                this.dataBody[index]["value"] = parseInt(
                  this.dataBody[index]["value"]
                );
              }
            }
            if (this.dataBody[index].type == "text") {
              if (
                this.dataBody[index]["label"] == "achievement" &&
                this.dataBody[index]["value"] != null
              ) {
                let tempData = JSON.parse(this.dataBody[index]["value"]);
                tempData.forEach((el, index) => {
                  this.achievement[index]["val"] = el;
                });
              }
              if (
                this.dataBody[index]["label"] == "historical_edu" &&
                this.dataBody[index]["value"] != null
              ) {
                let tempData = JSON.parse(this.dataBody[index]["value"]);
                tempData.forEach((el, index) => {
                  this.historical_edu[index]["val"] = el;
                });
              }
              if (
                this.dataBody[index]["label"] == "orgs_activity" &&
                this.dataBody[index]["value"] != null
              ) {
                let tempData = JSON.parse(this.dataBody[index]["value"]);
                tempData.forEach((el, index) => {
                  this.orgs_activity[index]["val"] = el;
                });
              }
              if (
                this.dataBody[index]["label"] == "acc_socmed" &&
                this.dataBody[index]["value"] != null
              ) {
                let tempData = JSON.parse(this.dataBody[index]["value"]);
                tempData.forEach((el) => {
                  for (let j = 0; j < this.acc_socmed.length; j++) {
                    if (el.name == this.acc_socmed[j]["name"]) {
                      this.acc_socmed[j]["value"] = el.value;
                    }
                  }
                });
              }
              if (
                this.dataBody[index]["label"] == "mother_latest_edu" &&
                this.dataBody[index]["value"] != null
              ) {
                let tempData = JSON.parse(this.dataBody[index]["value"]);
                tempData.forEach((el, index) => {
                  this.mother_latest_edu[index]["val"] = el;
                });
              }
              if (
                this.dataBody[index]["label"] == "father_latest_edu" &&
                this.dataBody[index]["value"] != null
              ) {
                let tempData = JSON.parse(this.dataBody[index]["value"]);
                tempData.forEach((el, index) => {
                  this.father_latest_edu[index]["val"] = el;
                });
              }
              if (
                this.dataBody[index]["label"] == "language_ability" &&
                this.dataBody[index]["value"] != null
              ) {
                let tempData = JSON.parse(this.dataBody[index]["value"]);
                tempData.forEach((el, index) => {
                  this.language_ability[index]["bahasa"] = el.bahasa;
                  this.language_ability[index]["Memiliki Sertifikasi"] =
                    el["Memiliki Sertifikasi"];
                  this.language_ability[index]["Jenis Tes"] = el["Jenis Tes"];
                  this.language_ability[index]["Skor"] = el["Skor"];
                  this.language_ability[index]["Tahun Sertifikat"] =
                    el["Tahun Srtifikat"];
                  this.language_ability[index]["No. Sertifikat"] =
                    el["No. Sertifikat"];
                  this.language_ability[index]["Nama Lembaga Bahasa"] =
                    el["Nama Lembaga Bahasa"];
                  this.language_ability[index]["Masa Berlaku"] =
                    el["Masa Berlaku"];
                });
              }
            }
          }
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    updateData() {
      this.loading = true;
      let historical_edu = [];
      this.historical_edu.forEach((el) => {
        historical_edu.push(el.val);
      });
      let achievement = [];
      this.achievement.forEach((el) => {
        achievement.push(el.val);
      });
      let orgs_activity = [];
      this.orgs_activity.forEach((el) => {
        orgs_activity.push(el.val);
      });
      let father_latest_edu = [];
      this.father_latest_edu.forEach((el) => {
        father_latest_edu.push(el.val);
      });
      let mother_latest_edu = [];
      this.mother_latest_edu.forEach((el) => {
        mother_latest_edu.push(el.val);
      });
      let body = [
        {
          id: this.dataSet.user_id,
        },
        {
          acc_socmed: JSON.stringify(this.acc_socmed),
        },
        {
          historical_edu: JSON.stringify(historical_edu),
        },
        {
          achievement: JSON.stringify(achievement),
        },
        {
          orgs_activity: JSON.stringify(orgs_activity),
        },
        {
          language_ability: JSON.stringify(this.language_ability),
        },
        {
          father_latest_edu: JSON.stringify(father_latest_edu),
        },
        {
          mother_latest_edu: JSON.stringify(mother_latest_edu),
        },
      ];
      for (let index = 0; index < this.dataBody.length; index++) {
        if (
          this.dataBody[index].name != "acc_socmed" &&
          this.dataBody[index].name != "historical_edu" &&
          this.dataBody[index].name != "achievement" &&
          this.dataBody[index].name != "orgs_activity" &&
          this.dataBody[index].name != "language_ability" &&
          this.dataBody[index].name != "father_latest_edu" &&
          this.dataBody[index].name != "mother_latest_edu" &&
          this.dataBody[index].name != "username" &&
          this.dataBody[index].name != "password" &&
          this.dataBody[index].name != "profile_picture"
        ) {
          if (this.dataBody[index].type != "text") {
            body.push({
              [this.dataBody[index].name]: this.dataBody[index].value,
            });
          } else {
            if (this.dataBody[index].valueChange) {
              body.push({
                [this.dataBody[index].name]: this.dataBody[index].valueChange,
              });
            }
          }
        }
      }
      let data = {
        path: `manage/scholar/update`,
        body: body,
      };

      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$router.go(-1);
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.error = e.message;
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
